import React, { Component } from "react";
import "./style.css";

export const RegistrationForm = ({
  hideForm,
  onSubmit,
  inputs,
  interests,
  isLoading,
  handleInterests,
  formError,
  finished,
  handleChange,
  state,
  changeSerialByIndex,
  addAnotherSerial,
  appRegistration,
  scrollDiv,
  removeSerial,
  xtupleResponse,
}) => {
  return (
    <div className="container overflow-hidden position-relative">
      <div className="form-content">
        <header className="header">
          <img
            src="https://cdn.shopify.com/s/files/1/0095/4332/files/icon_74294ebb-6813-4acb-81c6-25fe1c2b94b1.svg?v=1726212284"
            className="mb-2 fw-light"
            alt="clipboard"
          />
          <p className="fs-1 text-black mb-2 fw-normal ">
            Product Registration
          </p>
          <p className=" mb-md-8 fs-5 fw-normal mb-10 text-gray-4">
            Thank you for your purchase. Fill out the form
            <br className="d-block d-md-none"></br> below to register your
            product.
          </p>
        </header>
        <FormComponent
          hideForm={hideForm}
          onSubmit={onSubmit}
          inputs={inputs}
          interests={interests}
          isLoading={isLoading}
          handleInterests={handleInterests}
          formError={formError}
          handleChange={handleChange}
          state={state}
          changeSerialByIndex={changeSerialByIndex}
          addAnotherSerial={addAnotherSerial}
          appRegistration={appRegistration}
          scrollDiv={scrollDiv}
          removeSerial={removeSerial}
          xtupleResponse={xtupleResponse}
        />
        <Thankyou interests={interests} finished={finished} />
        <RegisterAnotherApp finished={finished} />
      </div>
    </div>
  );
};

const FormComponent = ({
  hideForm,
  onSubmit,
  inputs,
  interests,
  isLoading,
  handleInterests,
  formError,
  handleChange,
  state,
  changeSerialByIndex,
  addAnotherSerial,
  appRegistration,
  scrollDiv,
  removeSerial,
  xtupleResponse,
}) => {
  return (
    <form
      className={`form  ${hideForm ? "hide" : ""}`}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <div className="formGroup">
        <Input
          index={0}
          input={inputs.find((input) => input.id === "firstName")}
          error={inputs.find((input) => input.id === "firstName").errorMessage}
          value={state["firstName"]}
          type="text"
          placeholder="First Name"
          handleChange={handleChange}
          disabled={isLoading}
          required={true}
          id="firstName"
          className=""
        />
        <Input
          index={1}
          input={inputs.find((input) => input.id === "lastName")}
          error={inputs.find((input) => input.id === "lastName").errorMessage}
          value={state["lastName"]}
          type="text"
          placeholder="Last Name"
          handleChange={handleChange}
          disabled={isLoading}
          required={true}
          id="lastName"
          className=""
        />
      </div>
      <div className="formGroup">
        <Input
          index={2}
          input={inputs.find((input) => input.id === "email")}
          error={inputs.find((input) => input.id === "email").errorMessage}
          value={state["email"]}
          type="email"
          placeholder="Email"
          handleChange={handleChange}
          disabled={isLoading}
          required={true}
          id="email"
          className=""
        />
        <Input
          index={3}
          input={inputs.find((input) => input.id === "company")}
          error={inputs.find((input) => input.id === "company").errorMessage}
          value={state["company"]}
          type="text"
          placeholder="Company/Organization"
          handleChange={handleChange}
          disabled={isLoading}
          //   required={true}
          id="company"
          className=""
        />
      </div>
      <Serial
        input={inputs.find((input) => input.id === "serials")}
        changeSerialByIndex={changeSerialByIndex}
        addAnotherSerial={addAnotherSerial}
        appRegistration={appRegistration}
        scrollDiv={scrollDiv}
        removeSerial={removeSerial}
        xtupleResponse={xtupleResponse}
        disabled={isLoading}
        id="serials"
      />
      <div className="leftAlign ">
        <p className="info mb-2">
          <img
            src="https://cdn.shopify.com/s/files/1/0095/4332/files/v6-icon_0059c7b7-ac85-4438-af50-578a6da8ab1b.svg?v=1728045848"
            alt="info"
          />
          <span className="fs-md-7 fs-6 fw-normal">
            Most serial numbers are 8-10 digits long and do not include the
            revision letter.
          </span>
        </p>
        <p className="info mb-2">
          <img
            src="https://cdn.shopify.com/s/files/1/0095/4332/files/v6-icon_0059c7b7-ac85-4438-af50-578a6da8ab1b.svg?v=1728045848"
            alt="info"
          />
          <span className="fs-md-7 fs-6 fw-normal">
            Enter each serial number separately.
          </span>
        </p>
        <p
          className={`info cursor fw-bold text-gray-3  ${
            isLoading ? "disabled" : ""
          }`}
          onClick={addAnotherSerial}
        >
          <img
            src="https://cdn.shopify.com/s/files/1/0095/4332/files/Button_Icons.svg?v=1728045848"
            alt="plus"
            className="me-2"
          ></img>
          <span className="addProduct fw-bold">Add another product</span>
        </p>
      </div>
      <div className="formGroupCheckbox">
        <div className="info">
          <input
            type="checkbox"
            id="emails"
            className="checkbox"
            value={interests}
            onChange={handleInterests}
          />
          <label htmlFor="emails" className="label fw-normal fs-md-8 fs-7">
            Also sign me up to receive emails about our other events,
            promotions, and other marketing communications from Teradek.
          </label>
        </div>

        <div className="termsandcondition-container info">
          <input
            type="checkbox"
            id="termsandcondition"
            className="checkbox"
            // required={true}
            value={state.termsandcondition}
            onChange={() =>
              handleChange("termsandcondition", !state.termsandcondition)
            }
          />
          <label
            htmlFor="termsandcondition"
            className="label fw-normal fs-md-8 fs-7"
          >
            By checking this box you confirm that you have read and agree to our{" "}
            <a
              href="https://teradek.com/pages/terms-services"
              className="link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="https://teradek.com/pages/privacy-policy"
              className="link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
            .<span className="text-red-3">*</span>
          </label>
        </div>
        {state.termsandconditionerror && (
          <p id="termsandconditionerror" className="error-message">
            Please agree to terms of service.
          </p>
        )}
      </div>

      <div className="bottom-text mb-md-8 mb-10">
        Having trouble?{" "}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.teradek.com/pages/contact-us"
          className="link"
        >
          Let us know.
        </a>
      </div>
      {formError && (
        <h3 style={{ margin: "10px", color: "red" }}>{formError}</h3>
      )}
      <button
        type="submit"
        className="submitButton btn-black fs-md-6 fs-5 py-md-4 px-md-6 fw-bold fs-5 py-5 px-7"
        disabled={isLoading}
      >
        {isLoading ? "Submitting..." : "Submit"}
      </button>
    </form>
  );
};

class Input extends Component {
  componentDidMount() {
    this.triggerInitialBlur();
  }

  handlePlaceholderClick = (event) => {
    const parentDiv = event.target.closest(".input-group-custom");
    if (parentDiv) {
      const inputElement = parentDiv.querySelector(".inputHalf");
      if (inputElement) {
        inputElement.focus();
      }
    }
  };

  handleInputFocus = (event) => {
    const placeholder = event.target.parentNode.querySelector(
      ".placeholder-custom"
    );
    if (placeholder) {
      placeholder.classList.add("placeholder-small");
    }
  };

  handleInputBlur = (event) => {
    const placeholder = event.target.parentNode.querySelector(
      ".placeholder-custom"
    );
    if (placeholder && event.target.value.length === 0) {
      placeholder.classList.remove("placeholder-small");
    }
  };

  triggerInitialBlur = () => {
    const formControlElements = document.querySelectorAll(".required");
    formControlElements.forEach((input) => {
      if (input.value.length === 0) {
        const placeholder = input.parentNode.querySelector(
          ".placeholder-custom"
        );
        if (placeholder) {
          placeholder.classList.remove("placeholder-small");
        }
      }
    });
  };

  hidePlaceHolder = (event) => {
    const placeholder = event.target.parentNode.querySelector(
      ".placeholder-custom"
    );
    if (placeholder) {
      placeholder.style.display = "none";
    }
  };

  showPlaceHolder = (event) => {
    const placeholder = event.target.parentNode.querySelector(
      ".placeholder-custom"
    );
    if (placeholder && event.target.value.length === 0) {
      placeholder.style.display = "";
    }
  };

  handleInputChange = (event) => {
    if (event.target.value) {
      this.hidePlaceHolder(event);
    } else {
      this.showPlaceHolder(event);
    }

    this.props.handleChange(event.target.id, event.target.value);
  };

  render() {
    const {
      index,
      input,
      type,
      placeholder,
      value,
      required = false,
      disabled,
    } = this.props;
    return (
      <div
        key={index}
        id={input.id}
        className="input-group-custom font-family-hk-grotesk-pro"
      >
        <div
          className="placeholder-custom "
          onClick={this.handlePlaceholderClick}
        >
          <label for="email">{placeholder} </label>
          {required && <span className="star">*</span>}
        </div>
        <input
          type={type}
          className={`inputHalf font-family-hk-grotesk-pro ${
            input.errorMessage ? "input-error" : ""
          } ${required ? "required" : ""}`}
          id={input.id}
          value={value}
          onFocus={this.handleInputFocus}
          onBlur={this.handleInputBlur}
          onChange={(e) => {
            if (e.target.value.length > 254) {
              return;
            }
            this.handleInputChange(e);
          }}
          style={{ width: "100%" }}
          disabled={disabled}
        />

        {input.errorMessage && (
          <p className="error-message">{input.errorMessage}</p>
        )}
      </div>
    );
  }
}

class Serial extends Component {
  handleKeyPress = (e, index) => {
    const key = e.charCode || e.keyCode || 0;
    if (key === 13) {
      this.props.addAnotherSerial(index);
      e.preventDefault();
    }
  };

  handlePlaceholderClick = (event) => {
    const parentDiv = event.target.closest(".formGroupSerial");
    if (parentDiv) {
      const inputElement = parentDiv.querySelector(".inputSerial");
      if (inputElement) {
        inputElement.focus();
      }
    }
  };

  handleInputFocus = (event) => {
    const placeholder = event.target.parentNode.querySelector(
      ".placeholder-custom"
    );
    if (placeholder) {
      placeholder.classList.add("placeholder-small");
    }
  };

  handleInputBlur = (event) => {
    const placeholder = event.target.parentNode.querySelector(
      ".placeholder-custom"
    );
    if (placeholder && event.target.value.length === 0) {
      placeholder.classList.remove("placeholder-small");
    }
  };

  hidePlaceHolder = (event) => {
    const placeholder = event.target.parentNode.querySelector(
      ".placeholder-custom"
    );
    if (placeholder) {
      placeholder.style.display = "none";
    }
  };

  showPlaceHolder = (event) => {
    const placeholder = event.target.parentNode.querySelector(
      ".placeholder-custom"
    );
    if (placeholder && event.target.value.length === 0) {
      placeholder.style.display = "";
    }
  };

  handleInputChange = (event, input, index) => {
    const value = event.target.value;
    if (event.target.value) {
      this.hidePlaceHolder(event);
    } else {
      this.showPlaceHolder(event);
    }

    this.props.changeSerialByIndex(input, index, value);
  };

  render() {
    const { input, scrollDiv, removeSerial, xtupleResponse, disabled } =
      this.props;

    return (
      <div className="formGroupSerialContainer font-family-hk-grotesk-pro">
        {input.entries.map((each, index) => {
          return (
            <>
              <div ref={scrollDiv} key={each.id} className="formGroupSerial mb-6">
                <div
                  className="placeholder-custom"
                  onClick={this.handlePlaceholderClick}
                >
                  <label htmlFor={`serial-${index}`}>
                    Product Serial Number
                  </label>
                  <span className="star">*</span>
                </div>
                <input
                  type="text"
                  id={`serial-${index}`}
                  onKeyDown={(e) => this.handleKeyPress(e, index)}
                  className={`inputSerial font-family-hk-grotesk-pro ${
                    xtupleResponse && each.errorMessage ? "input-error" : ""
                  }`}
                  value={each.value}
                  onFocus={this.handleInputFocus}
                  onBlur={this.handleInputBlur}
                  onChange={(e) => this.handleInputChange(e, input, index)}
                />
                <button
                  className="close-button-custom"
                  onClick={() => removeSerial(index)}
                  type="button"
                  disabled={disabled}
                >
                  <p style={{ margin: 0, padding: 0 }}>
                    <i className="fas fa-times"></i>
                  </p>
                </button>
              </div>
              {xtupleResponse === true && (
                <p
                  className="error-message mt-n4 w-100"
                >
                  {!!each.errorMessage ? each.errorMessage : ""}
                </p>
              )}
            </>
          );
        })}
        {input.errorMessage && (
          <p className="error-message">{input.errorMessage}</p>
        )}
      </div>
    );
  }
}

const Thankyou = ({ finished, interests }) => {
  if (!finished) return null;

  return (
    <div style={{ margin: "0px 20px" }}>
      <div
        id="thank-you"
        style={{
          margin: "50px auto 20px",
          maxWidth: "500px",
          border: "1px solid black",
          padding: "20px",
          borderRadius: "5px",
        }}
      >
        <h5 style={{ color: "black" }}>
          Great! Thanks for submitting your product(s) registration. Your
          product(s) will be registered once a verification process is
          completed.
        </h5>
        {interests && (
          <div>
            <h5 style={{ color: "black" }}>
              You've chosen to be updated via Email on product updates,
              exclusive deals, and special offers regarding your product(s).
            </h5>
            <h5 style={{ color: "black" }}>You can unsubscribe any time.</h5>
          </div>
        )}
        <h5 style={{ color: "black" }}>
          Check out{" "}
          <a href="http://support.teradek.com">http://support.teradek.com</a> to
          help you get started on using your products.
        </h5>
      </div>
    </div>
  );
};

const RegisterAnotherApp = ({ finished }) => {
  if (!finished) return null;

  return (
    <p
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        window.location.href = window.location.origin;
      }}
      style={{
        color: "#2196f3",
        fontSize: "1.2em",
        paddingTop: "20px",
      }}
    >
      Register another product
    </p>
  );
};
